import { useMemo } from 'react';

import { ColumnDef } from '@tanstack/react-table';
import { ESectionOfferType } from 'constants/enums';

import ActionCell from 'components/DataTableComponent/components/ActionCell';

import { SectionsItem } from '../../StoreTheme/storeTheme.types';

const offerTypeLabel = (t?: ESectionOfferType) =>
  t === ESectionOfferType.PROMOTION ? 'Promotion' : 'Bundle';

export function useSectionsColumns({
  startEdit,
  removeRow
}: {
  startEdit: (row: SectionsItem) => void;
  removeRow: (id: string) => void;
}) {
  return useMemo((): ColumnDef<SectionsItem>[] => {
    return [
      {
        id: 'drag',
        header: '',
        size: 48,
        cell: () => null
      },
      {
        id: 'image',
        header: 'Image',
        cell: ({ row }) => {
          const img = row.original.image;
          return img ? (
            <img
              src={img}
              alt={`${row.original.name} icon`}
              className="h-10 w-10 rounded object-cover"
            />
          ) : null;
        }
      },
      {
        accessorKey: 'publisherSectionId',
        header: 'ID',
        cell: ({ row }) => (
          <span className="block truncate font-sans text-sm text-base-foreground">
            {row.original.publisherSectionId}
          </span>
        )
      },
      {
        accessorKey: 'name',
        header: 'Name',
        cell: ({ row }) => (
          <span className="block truncate font-sans text-sm text-base-foreground">
            {row.original.name}
          </span>
        )
      },
      {
        id: 'offerType',
        header: 'Type',
        cell: ({ row }) => (
          <span className="font-sans text-sm text-base-foreground">
            {offerTypeLabel(row.original.offerType)}
          </span>
        )
      },
      {
        id: 'actions',
        header: '',
        size: 48,
        cell: ({ row }) => {
          const id = row.original.publisherSectionId;
          return (
            <ActionCell
              testId={`storeSettingsSectionMenu-${id}`}
              rowData={row.original}
              actions={[
                {
                  label: 'Edit',
                  handler: (data: SectionsItem) => startEdit(data),
                  testId: `storeSettingsSectionEdit-${id}`
                },
                {
                  label: 'Delete',
                  handler: (data: SectionsItem) =>
                    removeRow(data.publisherSectionId),
                  testId: `storeSettingsSectionRemove-${id}`
                }
              ]}
            />
          );
        }
      }
    ];
  }, [removeRow, startEdit]);
}
